import { useState } from "react";
import { ArrowUpRight, List, X, WhatsappLogo } from "@phosphor-icons/react";
import { WHATSAPP_URL } from "@/App";

const LINKS = [
  { id: "demo", label: "The Demo" },
  { id: "sectors", label: "Who It's For" },
  { id: "pricing", label: "Pricing" },
  { id: "faq", label: "FAQ" },
];

export default function Header({ onNavigate }) {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    onNavigate(id);
  };

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 bg-white border-b border-slate-300"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 h-16 flex items-center justify-between gap-4">
        <button
          data-testid="brand-wordmark"
          onClick={() => go("top")}
          className="flex items-center gap-2.5 group shrink-0"
        >
          <span className="w-4 h-4 bg-[#0284C7] transition-transform duration-150 group-hover:rotate-45" />
          <span className="font-heading font-black tracking-tight text-lg text-slate-900">
            THERMOGLASSPRO
          </span>
          <span className="hidden sm:inline font-mono text-[10px] tracking-[0.3em] text-slate-400 mt-1">
            MALTA
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-6" data-testid="header-nav">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm font-medium text-slate-600 hover:text-[#0284C7] transition-colors duration-150 tracking-wide"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3 shrink-0">
          <button
            data-testid="header-quote-btn"
            onClick={() => go("quote")}
            className="hidden sm:flex items-center gap-1.5 bg-[#0284C7] text-white text-xs sm:text-sm font-semibold px-3 sm:px-5 py-2.5 border border-[#0284C7] hover:bg-[#0369A1] hover:-translate-y-0.5 transition-[background-color,transform] duration-150"
          >
            Book a Free On-Site Demo
            <ArrowUpRight size={16} weight="bold" />
          </button>
          <button
            data-testid="mobile-menu-btn"
            onClick={() => setOpen(!open)}
            className="lg:hidden w-11 h-11 flex items-center justify-center border border-slate-300 text-slate-900 hover:border-[#0284C7] hover:text-[#0284C7] transition-colors duration-150"
            aria-label={open ? "Close menu" : "Open menu"}
          >
            {open ? <X size={22} weight="bold" /> : <List size={22} weight="bold" />}
          </button>
        </div>
      </div>

      {open && (
        <nav
          data-testid="mobile-nav"
          className="lg:hidden border-t border-slate-200 bg-white"
        >
          <button
            data-testid="mobile-nav-book-btn"
            onClick={() => go("quote")}
            className="w-full text-left px-5 py-4 font-heading font-bold text-lg text-white bg-[#0284C7] flex items-center justify-between"
          >
            Book a Free On-Site Demo
            <ArrowUpRight size={20} weight="bold" />
          </button>
          {LINKS.map((l, i) => (
            <button
              key={l.id}
              data-testid={`mobile-nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="w-full text-left px-5 py-4 font-heading font-bold text-lg text-slate-900 border-b border-slate-200 hover:text-[#0284C7] hover:bg-slate-50 transition-colors duration-150 flex items-center justify-between"
            >
              {l.label}
              <span className="font-mono text-xs text-slate-400">
                {String(i + 1).padStart(2, "0")}
              </span>
            </button>
          ))}
          <a
            data-testid="mobile-nav-whatsapp"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full px-5 py-4 font-heading font-bold text-lg text-[#0369A1] flex items-center gap-3 hover:bg-slate-50 transition-colors duration-150"
          >
            <WhatsappLogo size={22} weight="fill" />
            WhatsApp Us
          </a>
        </nav>
      )}
    </header>
  );
}
